/* lib/api/pricing.js — поставщики и закупочные цены (порт из frontend/src/lib/api/pricing.js, 1:1). */
import { apiFetch } from './client.js';

export const listSuppliers = (params = {}) => {
  const q = new URLSearchParams();
  if (params.archived) q.set('archived', '1');
  const qs = q.toString();
  return apiFetch(`/api/pricing/suppliers/${qs ? `?${qs}` : ''}`);
};
export const createSupplier = (body) =>
  apiFetch('/api/pricing/suppliers/', { method: 'POST', body });
export const patchSupplier = (id, body) =>
  apiFetch(`/api/pricing/suppliers/${id}/`, { method: 'PATCH', body });
export const deleteSupplier = (id) =>
  apiFetch(`/api/pricing/suppliers/${id}/`, { method: 'DELETE' });

export const listPrices = ({ card } = {}) => {
  const q = new URLSearchParams();
  if (card) q.set('card', String(card));
  const qs = q.toString();
  return apiFetch(`/api/pricing/prices/${qs ? `?${qs}` : ''}`);
};
export const createPrice = (body) =>
  apiFetch('/api/pricing/prices/', { method: 'POST', body });
export const deletePrice = (id) =>
  apiFetch(`/api/pricing/prices/${id}/`, { method: 'DELETE' });

export const PRICE_UNITS = [
  { slug: 'kg', label: '₽ / кг' },
  { slug: 'l', label: '₽ / л' },
  { slug: 'pcs', label: '₽ / шт' },
  { slug: 'g', label: '₽ / г' },
];
